import { Button } from "components/Button";
import { InputFormField } from "components/InputFormField";
import { Loading } from "components/Loading";
import { PlaceHolderNotExists } from "components/PlaceholderNotExists";
import { TableModifiedCards } from "components/TableModified/TableModifiedCards";
import { TableModifiedFilters } from "components/TableModified/TableModifiedFilters";
import { TableModifiedPagination } from "components/TableModified/TableModifiedPagination";
import { TableModifiedTable } from "components/TableModified/TableModifiedTable";
import React from "react";
import { useHistory } from "react-router-dom";
import { Container, TableSearchSponsors } from "./styles";
import { useSponsorsTable } from "./useExhibitorsTable";

const tableHead = [
  "Nome",
  "Nível de Patrocínio",
  "Número do Estande",
  "É Patrocinador",
  "E-mail de Contato",
  "Ordem",
];

export const SponsorsTable: React.FC = () => {
  const {
    loading,
    error,
    properties,
    exhibitorRows,
    exhibitorsCount,
    searchText,
    tableFilters,
    searchTextFormRef,
    pageNumber,
    exhibitorsPerPage,
    handleSearchTextFormSubmit,
    handleFilterChange,
    handleFilterRemove,
    handleSearchTextRemove,
    handlePageSelected,
    handleRowsPerPageChange,
    exhibitors,
    eventId,
  } = useSponsorsTable();

  const { push } = useHistory();

  const handleCreateExhibitor = () => {
    push(`/events/${eventId}/exhibitor/create`);
  };

  const handleEditExhibitor = (exhibitor: any) => {
    push(`/events/${eventId}/exhibitor/${exhibitor.exhibitorId}/edit`);
  };

  return (
    <Container>
      <div>
        <div
          style={{
            display: "flex",
            gap: "1rem",
            alignItems: "end",
            justifyContent: "space-between",
            marginBottom: "1rem",
          }}
        >
          <TableSearchSponsors
            className="table-search-sponsors"
            onSubmit={handleSearchTextFormSubmit}
            ref={searchTextFormRef}
            style={{ flex: 1 }}
          >
            <InputFormField
              label="Buscar expositores"
              autoFocus={true}
              name="searchText"
              marginBotton={"0"}
              backGround={"white"}
              defaultValue={searchText}
              block={true}
            />
            <Button label="Buscar" typeBtn="blue" type="submit" block={false} />
          </TableSearchSponsors>

          <Button
            label="Criar expositor"
            typeBtn="blue"
            onClick={handleCreateExhibitor}
            block={false}
          />
        </div>
      </div>
      <TableModifiedFilters
        filters={tableFilters}
        searchTextFilter={searchText}
        onFilterChange={handleFilterChange}
        onFilterRemove={handleFilterRemove}
        onSearchTextRemove={handleSearchTextRemove}
      />
      {loading ? (
        <Loading />
      ) : error ? (
        <PlaceHolderNotExists title="Erro ao se comunicar com o servidor" />
      ) : (
        <>
          <TableModifiedCards properties={properties} />
          <TableModifiedTable
            headerColumns={tableHead}
            rows={exhibitorRows}
            onRowClick={(_, rowIndex) => {
              if (exhibitors && exhibitors[rowIndex]) {
                handleEditExhibitor(exhibitors[rowIndex]);
              }
            }}
          />
        </>
      )}
      {exhibitorsCount > 0 ? (
        <TableModifiedPagination
          totalItemsCount={exhibitorsCount}
          pageNumber={pageNumber}
          rowsPerPage={exhibitorsPerPage}
          onPageSelected={handlePageSelected}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      ) : null}
    </Container>
  );
};
